import moment from "moment";
import { Colour_Tournament } from "./Utils";

export class Clock {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = localStorage.getItem("rugby-clock-on-air") === "true";
    this.name = "CLOCK";
    this.page = "8095";
    this.data = [];
    this.game = null;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.BS_SCENE = "BS-Clock";
  }

  async preview({ options }) {
    // if (options.kickoff) {
    //   this.startClock();
    // }
    this.onAir = true;
    localStorage.setItem("rugby-clock-on-air", "true");
  }

  async animate({ options }) {
    await this.sendAnimateOff({ page: this.page });
    this.onAir = false;

    let score = this.getScore(options?.game);
    this.data = [];

    this.data.push({
      name: "Period",
      value: { text: options.period.number },
    });
    this.data.push({
      name: "HomeScore",
      value: { text: score?.home_score },
    });
    this.data.push({
      name: "AwayScore",
      value: { text: score?.away_score },
    });
    if (options?.game) {
      this.data.push(
        {
          name: "HomeName",
          value: {
            text:
              options.game?.home_team?.variables?.big_screen_name?.toUpperCase() ??
              options.game?.home_team?.short_name?.toUpperCase(),
          },
        },
        {
          name: "AwayName",
          value: {
            text:
              options.game?.away_team?.variables?.big_screen_name?.toUpperCase() ??
              options.game?.away_team?.short_name?.toUpperCase(),
          },
        },
      );
    }

    this.sendUpdate(this.BS_SCENE, this.data);

    clearInterval(this.onAirTimeout);
    localStorage.setItem("rugby-clock-on-air", "true");
    this.updateData({ options })
      .then(() => {
        this.onAirTimeout = setTimeout(() => {
          this.onAir = true;
        }, 3000);

        this.sendAnimate({ page: this.page });
      })
      .catch((err) => {
        try {
          document.getElementById("status-container").style.display = "none";
          document.getElementById("error-container").style.display = "flex";
          document.getElementById("error").innerText = err;
        } catch (err) { }
      });
  }

  async updateData({ options }) {
    let period = options.period;

    this.showClockChallenges = options.showClockChallenges;
     this.showSinbinClock = options.showSinbinClock;
    this.game = options.game;

    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "0005";
      }).value = options.clockType === "hidden" ? "1" : "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0006";
      }).value =
        period?.number === 1
          ? "1st half"
          : period?.number === 2
            ? "2nd half"
            : period?.number === 3
              ? "GP ET 1st"
              : period?.number === 4
                ? "GP ET 2nd"
                : "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0104";
      }).value = options?.game?.home_team?.code || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "0105";
      }).value = options?.game?.away_team?.code || "";

      let kit = options.game.home_team_kit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0901";
      }).value =
        options?.game?.home_team?.short_name?.toUpperCase() +
        " " +
        kit?.toUpperCase();

      try {
        let stripeColour =
          options?.game?.home_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0121.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) { }

      kit = options.game.away_team_kit;

      xml.payload.field.find((item) => {
        return item.attr.name === "0902";
      }).value =
        options?.game?.away_team?.short_name?.toUpperCase() +
        " " +
        kit?.toUpperCase();

      try {
        let stripeColour =
          options?.game?.away_team?.variables?.[kit + "_kit_stripe_viz"];
        xml.payload.field.find((item) => {
          return item.attr.name === "0141.active"; // home team back colour
        }).value = stripeColour && stripeColour !== "" ? "1" : "0";
      } catch (err) { }

      let home_reds = options.game?.lineup?.home?.reduce((prev, curr) => {
        return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
      }, 0);

      let away_reds = options.game?.lineup?.away?.reduce((prev, curr) => {
        return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
      }, 0);
      let home_yellows = options.game?.lineup?.home?.reduce((prev, curr) => {
        return (prev += curr.yellow_card && !curr.red_card ? 1 : 0);
      }, 0);

      let away_yellows = options.game?.lineup?.away?.reduce((prev, curr) => {
        return (prev += curr.yellow_card && !curr.red_card ? 1 : 0);
      }, 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0020"; // HOME RED CARDS
      }).value = home_yellows || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0021"; // AWAY RED CARDS
      }).value = away_yellows || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0022"; // HOME RED CARDS
      }).value = home_reds || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0023"; // AWAY RED CARDS
      }).value = away_reds || 0;

      let score = this.getScore(options?.game);
      xml.payload.field.find((item) => {
        return item.attr.name === "0002"; // AWAY RED CARDS
      }).value = score?.home_score || 0;
      xml.payload.field.find((item) => {
        return item.attr.name === "0003"; // AWAY RED CARDS
      }).value = score?.away_score || 0;

      xml.payload.field.find((item) => {
        return item.attr.name === "0004";
      }).value = "";

      let home_challenges =
        (options?.period?.number <= 2 ? 1 : 2) -
        (options?.game?.home_challenges?.unsuccessful ?? 0);
      let away_challenges =
        (options?.period?.number <= 2 ? 1 : 2) -
        (options?.game?.away_challenges?.unsuccessful ?? 0);

      xml.payload.field.find((item) => {
        return item.attr.name === "0024";
      }).value = this.showClockChallenges ? home_challenges : "0";

      xml.payload.field.find((item) => {
        return item.attr.name === "0025";
      }).value = this.showClockChallenges ? away_challenges : "0";
      if (period?.number > 2) {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "1";
        xml.payload.field.find((item) => {
          return item.attr.name === "0008";
        }).value = "GP";
      } else {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "0";
      }

      if (options.clockType === "hidden") {
        xml.payload.field.find((item) => {
          return item.attr.name === "0007";
        }).value = "0";
        xml.payload.field.find((item) => {
          return item.attr.name === "0008";
        }).value = "";
      }

       xml.payload.field.find((item) => {
                return item.attr.name === "0201";
              }).value = '0';

      await this.updateVizPage({
        page: this.page,
        data: xml,
      }).catch((err) => {
        console.log(err);
      });
    } else {
      throw new Error("Could not update clock so did not animate it");
    }
  }

  animateOff({ options }) {
    this.onAir = false;
    localStorage.setItem("rugby-clock-on-air", "false");
    this.sendAnimateOff({ page: this.page });
  }
  async update({ options }) {
    let score = this.getScore(options?.game);
    if (options.action === "PERIOD") {
      this.period = options.period.number;
      this.data = [];
      this.data.push({
        name: "Period",
        value: { text: options.period.number },
      });
      this.sendUpdate(this.BS_SCENE, this.data);
    }
    if (this.onAir) {
      switch (options?.action || options?.type) {

        case "Popout":
          let xml_popout = await this.getVizPage({ page: this.page }).catch(
            (err) => {
              console.log(err);
            },
          );
          if (xml_popout) {
            if (options?.mode === 'in') {
               xml_popout.payload.field.find((item) => {
                  return item.attr.name === "0007";
                }).value = "0";
                xml_popout.payload.field.find((item) => {
                  return item.attr.name === "0008";
                }).value = "";

              let curr_value =  xml_popout.payload.field.find((item) => {
                return item.attr.name === "zz009";
              }).value;
               xml_popout.payload.field.find((item) => {
                return item.attr.name === "zz009";
              }).value = curr_value === '0' ? '1' : '0';

              xml_popout.payload.field.find((item) => {
                return item.attr.name === "0201";
              }).value = '1';

              xml_popout.payload.field.find((item) => {
                return item.attr.name === "0024";
              }).value = '0';

              xml_popout.payload.field.find((item) => {
                return item.attr.name === "0025";
              }).value = '0';

              let kit =
                options?.popout?.team?._id === options?.game?.home_team?._id
                  ? options?.game.home_team_kit
                  : options?.game.away_team_kit;

              xml_popout.payload.field.find((item) => {
                return item.attr.name === "0202";
              }).value = (options?.popout?.team?.short_name + " " + kit)?.toUpperCase();

              xml_popout.payload.field.find((item) => {
                return item.attr.name === "0203";
              }).value = options?.popout?.text ?? '';

            } else if (options?.mode === 'out') {
              xml_popout.payload.field.find((item) => {
                return item.attr.name === "0201";
              }).value = '0';
            }
          }
          await this.updateVizPage({
            page: this.page,
            data: xml_popout,
          }).catch((err) => {
            console.log(err);
          });
          this.sendAnimate({ page: this.page });
          break;
        case "Timeline":
          let xml = await this.getVizPage({ page: this.page }).catch(
            (err) => {
              console.log(err);
            },
          );
          if (xml) {
            let home_tries = options?.game?.home_scorers
              ?.filter(
                (s) =>
                  (s.type === "try" || s.type === "penalty_try") &&
                  s?.period <= options.half
              )
              ?.map((s) => {
                return "H" + (s?.game_time_minutes + 1);
              });

            let away_tries = options?.game?.away_scorers
              ?.filter(
                (s) =>
                  (s.type === "try" || s.type === "penalty_try") &&
                  s?.period <= options.half
              )
              ?.map((s) => {
                return "A" + (s?.game_time_minutes + 1);
              });

            let string = [
              options.half,
              ...(home_tries ?? []),
              ...(away_tries ?? []),
            ].join(",");

            xml.payload.field.find((item) => {
              return item.attr.name === "0030";
            }).value = string;

            xml.payload.field.find((item) => {
              return item.attr.name === "0026";
            }).value = options.half === 0 ? '0' : '1';

            xml.payload.field.find((item) => {
              return item.attr.name === "0027";
            }).value = 'Tries';

            xml.payload.field.find((item) => {
              return item.attr.name === "0029";
            }).value = options?.game?.opta_home_team_stats?.tries;

            xml.payload.field.find((item) => {
              return item.attr.name === "0028";
            }).value = options?.game?.opta_away_team_stats?.tries;

            await this.updateVizPage({
              page: this.page,
              data: xml,
            }).catch((err) => {
              console.log(err);
            });
            this.sendAnimate({ page: this.page });
          }
          break;
        default:
          
          if (!options.period?.finished){
          let home_reds = options.game?.lineup?.home?.reduce((prev, curr) => {
            return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
          }, 0);

          let away_reds = options.game?.lineup?.away?.reduce((prev, curr) => {
            return (prev += curr.red_card || curr.dbl_yellow_card ? 1 : 0);
          }, 0);
          let home_yellows = options.game?.lineup?.home?.reduce(
            (prev, curr) => {
              return (prev += curr.yellow_card && !curr.red_card ? 1 : 0);
            },
            0,
          );

          let away_yellows = options.game?.lineup?.away?.reduce(
            (prev, curr) => {
              return (prev += curr.yellow_card && !curr.red_card ? 1 : 0);
            },
            0,
          );
          let home_challenges =
            (options?.period?.number <= 2 ? 1 : 2) -
            (options?.game?.home_challenges?.unsuccessful ?? 0);
          let away_challenges =
            (options?.period?.number <= 2 ? 1 : 2) -
            (options?.game?.away_challenges?.unsuccessful ?? 0);

          if (options.clockType === "manual") {
            let minutes = document.getElementById("manual_minutes")?.innerText;

            let seconds = document.getElementById("manual_seconds")?.innerText;

            if (this.minutes !== minutes || this.seconds !== seconds) {
              this.minutes = minutes;
              this.seconds = seconds;
              if (seconds !== undefined && minutes !== undefined) {
                this.vizSharedMemory({
                  shared_memory:
                    "SMMSystem_SetValue|MASTER_CLOCK_UP_SHM|" +
                    this.minutes +
                    ":" +
                    this.seconds,
                });
              }
            }
          }

          if (home_yellows === 1) {
            let game_mins =
              options?.clockType === "manual"
                ? parseInt(document.getElementById("manual_minutes")?.innerText)
                : parseInt(
                  document.getElementById("stadium_minutes")?.innerText,
                );

            let game_secs =
              options?.clockType === "manual"
                ? parseInt(document.getElementById("manual_seconds")?.innerText)
                : parseInt(
                  document.getElementById("stadium_seconds")?.innerText,
                );
                
            if (options.clockType !== "hidden" && this.showSinbinClock) {
              if (!Number.isNaN(game_mins) && !Number.isNaN(game_secs)) {
                let duration = moment.duration({
                  minutes: game_mins,
                  seconds: game_secs,
                });
                let player = options.game?.lineup?.home?.find(
                  (p) => p.yellow_card && !p.red_card,
                );
                let duration_2 = moment.duration({
                  minutes: player?.sinbins?.at(-1)?.game_time_minutes,
                  seconds: player?.sinbins?.at(-1)?.game_time_seconds,
                });

                let total_sinbin = moment.duration({ minutes: 10 });

                let diff = total_sinbin.subtract(duration.subtract(duration_2));

                this.vizSharedMemory({
                  shared_memory:
                    "SMMSystem_SetValue|HOME_SINBIN_CLOCK_1_SHM|" +
                    Math.max(diff?.minutes(), 0) +
                    ":" +
                    Math.max(diff?.seconds(), 0)?.toString()?.padStart(2, "0"),
                });
              }
            } else {
              this.vizSharedMemory({
                shared_memory: "SMMSystem_SetValue|HOME_SINBIN_CLOCK_1_SHM| ",
              });
            }
          }
          if (away_yellows === 1) {
            let game_mins =
              options?.clockType === "manual"
                ? parseInt(document.getElementById("manual_minutes")?.innerText)
                : parseInt(
                  document.getElementById("stadium_minutes")?.innerText,
                );

            let game_secs =
              options?.clockType === "manual"
                ? parseInt(document.getElementById("manual_seconds")?.innerText)
                : parseInt(
                  document.getElementById("stadium_seconds")?.innerText,
                );
            if (options.clockType !== "hidden" &&  this.showSinbinClock ) {
              if (!Number.isNaN(game_mins) && !Number.isNaN(game_secs)) {
                let duration = moment.duration({
                  minutes: game_mins,
                  seconds: game_secs,
                });
                let player = options.game?.lineup?.away?.find(
                  (p) => p.yellow_card && !p.red_card,
                );
                let duration_2 = moment.duration({
                  minutes: player?.sinbins?.at(-1)?.game_time_minutes,
                  seconds: player?.sinbins?.at(-1)?.game_time_seconds,
                });

                let total_sinbin = moment.duration({ minutes: 10 });

                let diff = total_sinbin.subtract(duration.subtract(duration_2));

                this.vizSharedMemory({
                  shared_memory:
                    "SMMSystem_SetValue|AWAY_SINBIN_CLOCK_1_SHM|" +
                    Math.max(diff?.minutes(), 0) +
                    ":" +
                    Math.max(diff?.seconds(), 0)?.toString()?.padStart(2, "0"),
                });
              }
            } else {
              this.vizSharedMemory({
                shared_memory: "SMMSystem_SetValue|AWAY_SINBIN_CLOCK_1_SHM| ",
              });
            }
          }

          if (
            this.shot_clock !== options.shot_clock ||
            this.shot_clock_type !== options.shot_clock_type
          ) {
            this.shot_clock = options.shot_clock;
            this.shot_clock_type = options.shot_clock_type;
            if (
              options.shot_clock_state === "running" &&
              options?.clockType !== "hidden"
            ) {
              this.vizSharedMemory({
                shared_memory:
                  "SMMSystem_SetValue|MASTER_SHOT_CLOCK_SHM|" + this.shot_clock,
              });
            } else if (options?.clockType === "hidden") {
              this.vizSharedMemory({
                shared_memory: "SMMSystem_SetValue|MASTER_SHOT_CLOCK_SHM| ",
              });
            }
          }

          if (
            this.home_score !== (score.home_score || 0) ||
            this.away_score !== (score.away_score || 0) ||
            this.home_reds_total !== home_reds ||
            this.away_reds_total !== away_reds ||
            this.home_yellows_total !== home_yellows ||
            this.away_yellows_total !== away_yellows ||
            this.home_challenges !== home_challenges ||
            this.away_challenges !== away_challenges ||
            this.phase?.number_tackles !==
            options.game?.phase?.number_tackles ||
            this.phase?.caption !== options.game?.phase?.caption ||
            this.shot_clock_state !== options.shot_clock_state ||
            this.clockType !== options?.clockType
          ) {
            this.clockType = options?.clockType;
            this.shot_clock_state = options.shot_clock_state;
            this.phase = options.game?.phase;
            this.home_score = score?.home_score;
            this.away_score = score?.away_score;
            this.home_reds_total = home_reds;
            this.away_reds_total = away_reds;
            this.home_yellows_total = home_yellows;
            this.away_yellows_total = away_yellows;
            this.home_challenges = home_challenges;
            this.away_challenges = away_challenges;

            this.data = [];
            this.data.push({
              name: "Period",
              value: { text: options.period.number },
            });
            this.data.push({
              name: "HomeScore",
              value: { text: score?.home_score },
            });
            this.data.push({
              name: "AwayScore",
              value: { text: score?.away_score },
            });

            this.data.push(
              {
                name: "HomeName",
                value: {
                  text:
                    options.game?.home_team?.variables?.big_screen_name?.toUpperCase() ??
                    options.game?.home_team?.short_name?.toUpperCase(),
                },
              },
              {
                name: "AwayName",
                value: {
                  text:
                    options.game?.away_team?.variables?.big_screen_name?.toUpperCase() ??
                    options.game?.away_team?.short_name?.toUpperCase(),
                },
              },
            );

            this.data.push({
              name: "Home Nodes",
              value: { text: home_challenges },
            });
            this.data.push({
              name: "Away Nodes",
              value: { text: away_challenges },
            });

            this.data.push({
              name:
                window.ENV?.REACT_APP_CATALANS === "true" ||
                  process.env.REACT_APP_CATALANS === "true"
                  ? "FRENCH_TRY"
                  : "ENGLISH_TRY",
              value: {
                visible:
                  this.phase?.caption?.toUpperCase()?.indexOf("TRY CONFIRMED") >
                    -1
                    ? true
                    : false,
              },
            });

            this.sendUpdate(this.BS_SCENE, this.data);

            let xml = await this.getVizPage({ page: this.page }).catch(
              (err) => {
                console.log(err);
              },
            );
            if (xml) {
              if (options.period?.number > 2) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0007";
                }).value = "1";
                xml.payload.field.find((item) => {
                  return item.attr.name === "0008";
                }).value = "GP";
              } else {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0007";
                }).value = "0";
              }

              if (options.clockType === "hidden") {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0007";
                }).value = "0";
                xml.payload.field.find((item) => {
                  return item.attr.name === "0008";
                }).value = "";
              }

              xml.payload.field.find((item) => {
                return item.attr.name === "0005";
              }).value = options.clockType === "hidden" ? "1" : "0";

              xml.payload.field.find((item) => {
                return item.attr.name === "0002";
              }).value = score?.home_score || 0;
              xml.payload.field.find((item) => {
                return item.attr.name === "0003";
              }).value = score?.away_score || 0;
              // xml.payload.field.find((item) => {
              //   return item.attr.name === "0004";
              // }).value = "";

              xml.payload.field.find((item) => {
                return item.attr.name === "0009"; // HOME RED CARDS
              }).value = this.phase?.number_tackles > -1 ? "1" : "0";
              if (this.phase?.number_tackles > -1) {
                if (this.phase?.team) {
                  xml.payload.field.find((item) => {
                    return item.attr.name === "0010"; // HOME RED CARDS
                  }).value =
                    this.phase?.team === options?.game?.home_team?._id
                      ? "1"
                      : "2";
                }

                xml.payload.field.find((item) => {
                  return item.attr.name === "0011"; // HOME RED CARDS
                }).value = this.phase?.number_tackles;

                xml.payload.field.find((item) => {
                  return item.attr.name === "0012"; // HOME RED CARDS
                }).value = !options?.game?.competition?.variables?.disable_metres_popout ? this.phase?.metres : '';
              }
              let show_dropdown = false;
              if (this.phase?.caption && this.phase?.caption !== "") {
                show_dropdown = true;
              }
              // if (this.shot_clock_state === "running") {
              //   show_dropdown = true;

              //   if (
              //     this.shot_clock_type === "60" &&
              //     (!this.phase?.caption || this.phase?.caption === "")
              //   ) {
              //     show_dropdown = false;
              //   }
              // } else if (this.phase?.caption && this.phase?.caption !== "") {
              //   if (this.phase.caption?.indexOf("Kick") === -1) {
              //     show_dropdown = true;
              //   }
              // }

              xml.payload.field.find((item) => {
                return item.attr.name === "0013"; // HOME RED CARDS
              }).value = show_dropdown ? 1 : 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0014"; // HOME RED CARDS
              }).value =
                this.shot_clock_type === "60"
                  ? "Kick countdown"
                  : this.phase?.caption && this.phase?.caption !== ""
                    ? this.phase?.caption
                    : this.shot_clock_type !== ""
                      ? this.shot_clock_type
                        ?.replace("scrum", "Scrum")
                        ?.replace("dropout", "Goal Line Dropout")
                      : "";

              xml.payload.field.find((item) => {
                return item.attr.name === "0015"; // HOME RED CARDS
              }).value =
                this.phase?.caption_team === options?.game?.home_team?._id
                  ? "1"
                  : this.phase?.caption_team === options?.game?.away_team?._id
                    ? "2"
                    : "0";

              xml.payload.field.find((item) => {
                return item.attr.name === "0016"; // HOME RED CARDS
              }).value = this.shot_clock_state === "running" ? "1" : "0";

              xml.payload.field.find((item) => {
                return item.attr.name === "0020"; // HOME RED CARDS
              }).value = home_yellows || 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0021"; // AWAY RED CARDS
              }).value = away_yellows || 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0022"; // HOME RED CARDS
              }).value = home_reds || 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0023"; // AWAY RED CARDS
              }).value = away_reds || 0;

              xml.payload.field.find((item) => {
                return item.attr.name === "0024";
              }).value = this.showClockChallenges ? home_challenges : "0";

              xml.payload.field.find((item) => {
                return item.attr.name === "0025";
              }).value = this.showClockChallenges ? away_challenges : "0";

              if (
                score.home_tries > this.score?.home_tries ||
                score.away_tries > this.score?.away_tries
              ) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0004";
                }).value = "TRY";
              }

              if (
                score.home_conv > this.score?.home_conv ||
                score.away_conv > this.score?.away_conv
              ) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0004";
                }).value = "CONVERSION";
              }

              if (
                score.home_pen_kick > this.score?.home_pen_kick ||
                score.away_pen_kick > this.score?.away_pen_kick
              ) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0004";
                }).value = "PENALTY GOAL";
              }

              if (
                score.home_pen_try > this.score?.home_pen_try ||
                score.away_pen_try > this.score?.away_pen_try
              ) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0004";
                }).value = "PENALTY TRY";
              }

              if (
                score.home_drop_goal > this.score?.home_drop_goal ||
                score.away_drop_goal > this.score?.away_drop_goal
              ) {
                xml.payload.field.find((item) => {
                  return item.attr.name === "0004";
                }).value = "DROP GOAL";
              }

              this.score = score;
              await this.updateVizPage({
                page: this.page,
                data: xml,
              }).catch((err) => {
                console.log(err);
              });
              this.sendAnimate({ page: this.page });
            }
          }
        }
      }
    }
  }
  getScore(game) {
    let try_points = game?.competition?.competition_type === "union" ? 5 : 4;
    let conversion_points =
      game?.competition?.competition_type === "union" ? 2 : 2;
    let penalty_kick_points =
      game?.competition?.competition_type === "union" ? 3 : 2;
    let penalty_try_points =
      game?.competition?.competition_type === "union" ? 7 : 4;
    let drop_goal_points =
      game?.competition?.competition_type === "union" ? 3 : 1;

    let home_score =
      (game?.home_scorers?.filter((g) => g.type === "try").length *
        try_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "conversion").length *
        conversion_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "penalty_kick").length *
        penalty_kick_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "penalty_try").length *
        penalty_try_points || 0) +
      (game?.home_scorers?.filter((g) => g.type === "drop_goal").length *
        drop_goal_points || 0);
    let home_tries =
      game?.home_scorers?.filter((g) => g.type === "try").length || 0;
    let home_conv =
      game?.home_scorers?.filter((g) => g.type === "conversion").length || 0;
    let home_pen_kick =
      game?.home_scorers?.filter((g) => g.type === "penalty_kick").length || 0;
    let home_pen_try =
      game?.home_scorers?.filter((g) => g.type === "penalty_try").length || 0;
    let home_drop_goal =
      game?.home_scorers?.filter((g) => g.type === "drop_goal").length || 0;
    let away_score =
      (game?.away_scorers?.filter((g) => g.type === "try").length *
        try_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "conversion").length *
        conversion_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "penalty_kick").length *
        penalty_kick_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "penalty_try").length *
        penalty_try_points || 0) +
      (game?.away_scorers?.filter((g) => g.type === "drop_goal").length *
        drop_goal_points || 0);
    let away_tries =
      game?.away_scorers?.filter((g) => g.type === "try").length || 0;
    let away_conv =
      game?.away_scorers?.filter((g) => g.type === "conversion").length || 0;
    let away_pen_kick =
      game?.away_scorers?.filter((g) => g.type === "penalty_kick").length || 0;
    let away_pen_try =
      game?.away_scorers?.filter((g) => g.type === "penalty_try").length || 0;
    let away_drop_goal =
      game?.away_scorers?.filter((g) => g.type === "drop_goal").length || 0;
    return {
      home_score,
      away_score,
      home_tries,
      home_conv,
      home_pen_kick,
      home_pen_try,
      home_drop_goal,
      away_tries,
      away_conv,
      away_pen_kick,
      away_pen_try,
      away_drop_goal,
    };
  }
}
